<template>
	<div class="registry-container">
		<div class="header-actions">
			<h3>{{ people ? getString('people') : getString('companies') }}</h3>
			<AppSwitch left-icon="iconPerson" right-icon="iconCompany" fixed-color class="demo-switch" @switched="switchTable" ></AppSwitch>
		</div>
		<AppTable
			v-if="people"
			ref="people-table"
			:filters="filtersPeople"
			:fetch-function="fetchFunctionPeople"
			:table-headings="tableHeadingsPeople"
			:total-items="customersStore.customersPeopleTotal"
			:items="customersToShow"
			initial-sort-field="balance" >
			<template #before-table>
				<div class="row align-center space-between row-actions mb-10">
					<div class="left-column">
						<AppButton icon-left="icon-plus" small outline :text="getString('add_customer')" @click="newPersonSheet = true" />
					</div>
					<div class="right-column">
						<AppTextInput ref="search-input" icon-name="icon-magnify" :placeholder="getString('search')" @changed-text="v => searchPeople = v" />
					</div>
				</div>
			</template>
			<template #settingsIcon="{item, heading}">
				<div class="row centered">
					<AppTableButtonGroup :buttons="buttonsManagePerson" :item="item" @picked-manage-person="pickedManagePerson(item)"/>
				</div>
			</template>
		</AppTable>
		<AppTable
			v-else
			ref="companies-table"
			:filters="filtersCompanies"
			:fetch-function="fetchFunctionCompanies"
			:table-headings="tableHeadingsCompanies"
			:total-items="customersStore.customersCompaniesTotal"
			:items="companiesToShow"
			initial-sort-field="balance" >
			<template #before-table>
				<div class="row align-center space-between row-actions mb-10">
					<div class="left-column">
						<AppButton icon-left="icon-plus" small outline :text="getString('add_company')" @click="newCompanySheet = true" />
					</div>
					<div class="right-column">
						<AppTextInput ref="search-input" icon-name="icon-magnify" :placeholder="getString('search')" @changed-text="v => searchCompanies = v" />
					</div>
				</div>
			</template>
			<template #settingsIcon="{item, heading}">
				<div class="row centered">
					<AppTableButtonGroup :buttons="buttonsManageCompany" :item="item" @picked-manage-company="pickedManageCompany(item)" />
				</div>
			</template>
		</AppTable>

		<CustomersPeopleAdd :active="newPersonSheet" @toggling-popup="togglingPopupPerson" @added-customer="addedCustomer" />
		<CustomersCompanyAdd :active="newCompanySheet" @toggling-popup="togglingPopupCompany" @added-customer="addedCompany" />
		<CustomersPersonDetails :person-id="personSettings ? personSettings.customer_id : null" @deleted-customer="deletedPersonCustomer" @toggling-popup="togglingPopupPersonDetails" />
		<CustomersCompanyDetails :company-id="companySettings ? companySettings.customer_id : null" @deleted-company="deletedCompanyCustomer" @toggling-popup="togglingPopupCompanyDetails" />
	</div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useCustomersStore, useUserStore, useCounterStore} from "@/console-new/stores";
import AppTabsSwitch from "@/shared/components/AppTabsSwitch.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppTable from "@/shared/components/AppTable.vue";
import CustomersPeopleAdd from "@/console-new/components/ops/CustomersPeopleAdd.vue";
import {formatDateYYMMDD} from "@/shared/helpers/dates";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import CustomersCompanyAdd from "@/console-new/components/ops/CustomersCompanyAdd.vue";
import CustomersPersonDetails from "@/console-new/components/ops/CustomersPersonDetails.vue";
import CustomersCompanyDetails from "@/console-new/components/ops/CustomersCompanyDetails.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";
import AppTableButtonGroup from "@/shared/components/AppTableButtonGroup.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const customersStore = useCustomersStore();
		const currencyStore = useCurrencyStore();
		const counterStore = useCounterStore();
		return {getString: languageStore.getString, counterStore, showNotification: notificationStore.showNotification, userStore, currencyStore, customersStore, formatDateYYMMDD}
	},
	name: "CustomersRegistry",
	mixins: [WindowWidth],
	components: {
		AppTableButtonGroup,
		CustomersCompanyAdd, CustomersPersonDetails, CustomersCompanyDetails, AppBottomSheet, CustomersPeopleAdd, AppTable, AppTextInput, AppButtonIcon, AppTabsSwitch, AppList, ModalHeader, AppButton, AppSwitch},
	data() {
		return {
			personSettings: null,
			companySettings: null,
			people: true,
			searchPeople: null,
			searchCompanies: null,
			filtersPeople: [
				{
					type: "price",
					key: "balance",
					text: this.getString("balance"),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadingsPeople: [
				{
					text: this.getString('name'),
					cols: 2,
					sortable: true,
					fieldName: 'name',
				},
				{
					text: this.getString('balance'),
					cols: 1,
					sortable: true,
					fieldName: 'readable_balance',
				},
				{
					text: this.getString('manage'),
					cols: 1,
					fieldName: 'settings',
					slotName: 'settingsIcon',
				},
				{
					text: this.getString('email'),
					cols: 2,
					fieldName: 'email',
				},
				{
					text: this.getString('phone'),
					cols: 1,
					fieldName: 'phone',
				},
				{
					text: this.getString('birth_date'),
					cols: 1,
					fieldName: 'birth_date',
				},
			],
			tableHeadingsCompanies: [
				{
					text: this.getString('fiscal_name'),
					cols: 2,
					sortable: true,
					fieldName: 'name',
				},
				{
					text: this.getString('balance'),
					cols: 1,
					sortable: true,
					fieldName: 'readable_balance',
				},
				{
					text: this.getString('manage'),
					cols: 1,
					fieldName: 'settings',
					slotName: 'settingsIcon',
				},
				{
					text: this.getString('vat'),
					cols: 2,
					fieldName: 'vat_fallback',
				},
				{
					text: this.getString('cf'),
					cols: 1,
					fieldName: 'cf_fallback',
				},
				{
					text: this.getString('sdi'),
					cols: 1,
					fieldName: 'sdi',
				},
				{
					text: this.getString('country'),
					cols: 1,
					fieldName: 'country_code',
				},
				{
					text: this.getString('address'),
					cols: 3,
					fieldName: 'address',
				},
			],
			filtersCompanies: [
				{
					type: "price",
					key: "balance",
					text: this.getString("balance"),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			newPersonSheet: false,
			newCompanySheet: false,
		}
	},
	computed: {
		buttonsManageCompany() {
			return [
				{
					iconName: "icon-manage-blue",
					emitName: "picked-manage-company",
					title: this.getString('manage_company'),
				},
			];
		},
		buttonsManagePerson() {
				return [
				{
					iconName: "icon-manage-blue",
					emitName: "picked-manage-person",
					title: this.getString('manage_person'),
				},
			];
		},
		customersToShow() {
			return this.customersStore.customersPeople.map(customer => {
				return {
					...customer,
					email: customer.email || '-',
					phone: customer.phone || '-',
					birth_date: customer.birth_date ? this.formatDateYYMMDD(customer.birth_date) : '-',
					readable_balance: this.currencyStore.readableCurrencyValue(customer.balance),
				}
			});
		},
		companiesToShow() {
			return this.customersStore.customersCompanies.map(customer => {
				return {
					...customer,
					email: customer.email || '-',
					address: customer.address || '-',
					readable_balance: this.currencyStore.readableCurrencyValue(customer.balance),
				}
			});
		},
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
	},
	methods: {
		pickedManageCompany(item) {
			this.companySettings = item;
			this.counterStore.registryEditingCustomer = {...item, type: 'company'};
		},
		pickedManagePerson(item) {
			this.personSettings = item;
			this.counterStore.registryEditingCustomer = {...item, type: 'person'};
		},
		fetchFunctionPeople(filters, callback) {
			if(this.searchPeople && this.searchPeople.length > 2) {
				filters.name = "%" + this.searchPeople + "%";
			}
			if(filters.sort && filters.sort === 'readable_balance') {
				filters.sort = 'balance';
			}
			return this.customersStore.getFilteredPeople(filters, callback);
		},
		fetchFunctionCompanies(filters, callback) {
			if(this.searchCompanies && this.searchCompanies.length > 2) {
				filters.name = "%" + this.searchCompanies + "%";
			}
			if(filters.sort && filters.sort === 'readable_balance') {
				filters.sort = 'balance';
			}
			return this.customersStore.getFilteredCompanies(filters, callback);
		},
		togglingPopupPerson(isOpen) {
			if(!isOpen) {
				this.newPersonSheet = false;
			}
		},
		togglingPopupCompany(isOpen) {
			if(!isOpen) {
				this.newCompanySheet = false;
			}
		},
		togglingPopupPersonDetails(isOpen) {
			if(!isOpen) {
				this.personSettings = null;
				this.counterStore.registryEditingCustomer = null;
				this.$refs && this.$refs['people-table'] && this.$refs['people-table'].fetchData();
			}
		},
		togglingPopupCompanyDetails(isOpen) {
			if(!isOpen) {
				this.companySettings = null;
				this.counterStore.registryEditingCustomer = null;
				this.$refs && this.$refs['companies-table'] && this.$refs['companies-table'].fetchData();
			}
		},
		addedCustomer() {
			this.newPersonSheet = false;
			this.$refs && this.$refs['people-table'] && this.$refs['people-table'].fetchData();
		},
		addedCompany() {
			this.newCompanySheet = false;
			this.$refs && this.$refs['companies-table'] && this.$refs['companies-table'].fetchData();
		},
		deletedPersonCustomer() {
			this.personSettings = null;
			this.counterStore.registryEditingCustomer = null;
			this.$refs && this.$refs['people-table'] && this.$refs['people-table'].fetchData();
		},
		deletedCompanyCustomer() {
			this.companySettings = null;
			this.counterStore.registryEditingCustomer = null;
			this.$refs && this.$refs['companies-table'] && this.$refs['companies-table'].fetchData();
		},
		switchTable() {
			this.people = !this.people;
			this.searchPeople = null;
		},
	},
	watch: {
		searchPeople(newValue, oldValue) {
			if(newValue !== oldValue) {
				this.$refs && this.$refs['people-table'] && this.$refs['people-table'].fetchData();
			}
		},
		searchCompanies(newValue, oldValue) {
			if(newValue !== oldValue) {
				this.$refs && this.$refs['companies-table'] && this.$refs['companies-table'].fetchData();
			}
		},
	}
}
</script>

<style scoped lang="scss">
.row-actions {
	padding: 10px;
	gap: 8px;
	background-color: var(--color-bg-primary-2);
	border-radius: 13px 13px 0 0;

	.right-column {
		display: flex;
		align-items: center;
		margin-left: auto;
	}

	.input-wrapper {
		width: 200px;

		@media (max-width: 1050px) {
			width: 140px;
		}

		@media (max-width: 900px) {
			width: 130px;

			:deep(.input-element) {

				img {
					width: 14px;
					height: 14px;
				}

				input {
					height: 27px;
					padding-left: 32px;
				}
			}
		}

		@media (max-width: 420px) {
			width: 120px;
		}

	}
}
.registry-container {
	.header-actions {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--color-bg-primary-2);
		border-radius: 13px;
		padding: 10px;
		box-shadow: inset 0 1px 2px var(--color-alpha-4);
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 10px;
	}
	:deep(.table-wrapper){
		padding-top: 0;
	}
 :deep(.card-container) {
	 box-shadow: none;
	 .card-header {
		 display: none;
	 }
 }
}
</style>